import { isEmpty, trimEnd } from 'lodash';
import seo from '../../../locales/th/seo.json';
import logo from '../../assets/tol-logo-text.jpg';
import config from '../../config';
import { handleShareImageUrl } from '../sharpie/imageUrlHelper';
import {
  getAllPropertyTypeValues,
  PropertyType,
} from '../domain/propertyTypes';
import { AdvanceSearchQueries } from '../../../pages/searchResultPage/SearchResultPage';
import { LandingPageTypes } from '../domain/landingPages';

const WEBSITE_NAME = ' | thinkofliving.com';

const titleMetaDescriptionResourceMap = new Map<
  LandingPageTypes,
  Record<string, string>
>([
  [
    LandingPageTypes.CondoPage,
    {
      title: seo.condoPage.title,
      description: seo.condoPage.metaDescription,
      schemaName: seo.condoPage.schemaName,
      schemaDescription: seo.condoPage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.HousePage,
    {
      title: seo.housePage.title,
      description: seo.housePage.metaDescription,
      schemaName: seo.housePage.schemaName,
      schemaDescription: seo.housePage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.TownhomePage,
    {
      title: seo.townhomePage.title,
      description: seo.townhomePage.metaDescription,
      schemaName: seo.townhomePage.schemaName,
      schemaDescription: seo.townhomePage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.VacationPage,
    {
      title: seo.holidayHomesPage.title,
      description: seo.holidayHomesPage.metaDescription,
      schemaName: seo.holidayHomesPage.schemaName,
      schemaDescription: seo.holidayHomesPage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.HomeOfficePage,
    {
      title: seo.homeOfficePage.title,
      description: seo.homeOfficePage.metaDescription,
      schemaName: seo.homeOfficePage.schemaName,
      schemaDescription: seo.homeOfficePage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.MixedUsePage,
    {
      title: seo.mixedUsePage.title,
      description: seo.mixedUsePage.metaDescription,
      schemaName: seo.mixedUsePage.schemaName,
      schemaDescription: seo.mixedUsePage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.CommercialBuildingPage,
    {
      title: seo.commercialPage.title,
      description: seo.commercialPage.metaDescription,
      schemaName: seo.commercialPage.schemaName,
      schemaDescription: seo.commercialPage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.ProjectResearchPage,
    {
      title: seo.projectResearchPage.title,
      description: seo.projectResearchPage.metaDescription,
      schemaName: seo.projectResearchPage.schemaName,
      schemaDescription: seo.projectResearchPage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.PreviewPage,
    {
      title: seo.previewPage.title,
      description: seo.previewPage.metaDescription,
      schemaName: seo.previewPage.schemaName,
      schemaDescription: seo.previewPage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.ReviewPage,
    {
      title: seo.reviewPage.title,
      description: seo.reviewPage.metaDescription,
      schemaName: seo.reviewPage.schemaName,
      schemaDescription: seo.reviewPage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.PointOfViewPage,
    {
      title: seo.pointOfViewPage.title,
      description: seo.pointOfViewPage.metaDescription,
      schemaName: seo.pointOfViewPage.schemaName,
      schemaDescription: seo.pointOfViewPage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.LocationInsightPage,
    {
      title: seo.locationInsightPage.title,
      description: seo.locationInsightPage.metaDescription,
      schemaName: seo.locationInsightPage.schemaName,
      schemaDescription: seo.locationInsightPage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.ZonesPage,
    {
      title: seo.zonesPage.title,
      description: seo.zonesPage.metaDescription,
    },
  ],
  [
    LandingPageTypes.TrainlinesPage,
    {
      title: seo.trainlinesPage.title,
      description: seo.trainlinesPage.metaDescription,
    },
  ],
  [
    LandingPageTypes.NewsPage,
    {
      title: seo.newsPage.title,
      description: seo.newsPage.metaDescription,
      schemaName: seo.newsPage.schemaName,
      schemaDescription: seo.newsPage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.PropertyNewsPage,
    {
      title: seo.propertyNewsPage.title,
      description: seo.newsPage.metaDescription,
    },
  ],
  [
    LandingPageTypes.GeneralNewsPage,
    {
      title: seo.generalNewsPage.title,
      description: seo.generalNewsPage.metaDescription,
    },
  ],
  [
    LandingPageTypes.GuidesPage,
    {
      title: seo.guidePage.title,
      description: seo.guidePage.metaDescription,
      schemaName: seo.guidePage.schemaName,
      schemaDescription: seo.guidePage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.BuyAndSellPage,
    {
      title: seo.buyAndSellPage.title,
      description: seo.buyAndSellPage.metaDescription,
    },
  ],
  [
    LandingPageTypes.InvestmentPage,
    {
      title: seo.investmentPage.title,
      description: seo.investmentPage.metaDescription,
    },
  ],
  [
    LandingPageTypes.FinancePage,
    {
      title: seo.financePage.title,
      description: seo.financePage.metaDescription,
    },
  ],
  [
    LandingPageTypes.DecorsPage,
    {
      title: seo.decorPage.title,
      description: seo.decorPage.metaDescription,
      schemaName: seo.decorPage.schemaName,
      schemaDescription: seo.decorPage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.InteriorInspirationPage,
    {
      title: seo.interiorInspirationPage.title,
      description: seo.interiorInspirationPage.metaDescription,
    },
  ],
  [
    LandingPageTypes.RenovationPage,
    {
      title: seo.renovationPage.title,
      description: seo.renovationPage.metaDescription,
    },
  ],
  [
    LandingPageTypes.MaintenancePage,
    {
      title: seo.maintenancePage.title,
      description: seo.maintenancePage.metaDescription,
    },
  ],
  [
    LandingPageTypes.ReviewCondoPage,
    {
      title: seo.reviewCondoPage.title,
      description: seo.reviewCondoPage.metaDescription,
      schemaName: seo.reviewCondoPage.schemaName,
      schemaDescription: seo.reviewCondoPage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.ReviewHousePage,
    {
      title: seo.reviewHousePage.title,
      description: seo.reviewHousePage.metaDescription,
      schemaName: seo.reviewHousePage.schemaName,
      schemaDescription: seo.reviewHousePage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.ReviewTownhomePage,
    {
      title: seo.reviewTownhomePage.title,
      description: seo.reviewTownhomePage.metaDescription,
      schemaName: seo.reviewTownhomePage.schemaName,
      schemaDescription: seo.reviewTownhomePage.schemaName,
    },
  ],
  [
    LandingPageTypes.PreviewCondoPage,
    {
      title: seo.previewCondoPage.title,
      description: seo.previewCondoPage.metaDescription,
      schemaName: seo.previewCondoPage.schemaName,
      schemaDescription: seo.previewCondoPage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.PreviewHousePage,
    {
      title: seo.previewHousePage.title,
      description: seo.previewHousePage.metaDescription,
      schemaName: seo.previewHousePage.schemaName,
      schemaDescription: seo.previewHousePage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.PreviewTownhomePage,
    {
      title: seo.previewTownhomePage.title,
      description: seo.previewTownhomePage.metaDescription,
      schemaName: seo.previewTownhomePage.schemaName,
      schemaDescription: seo.previewTownhomePage.schemaDescription,
    },
  ],
  [
    LandingPageTypes.HomePage,
    {
      title: seo.homePage.title,
      description: seo.homePage.metaDescription,
      schemaName: seo.homePage.schemaName,
      schemaDescription: seo.homePage.schemaDescription,
    },
  ],
]);

const getTitleMetaDescription = (
  pageType: LandingPageTypes,
): Record<string, string> => titleMetaDescriptionResourceMap.get(pageType);

export function getLandingPageMeta(pageType: LandingPageTypes) {
  return getTitleMetaDescription(pageType);
}

export function contentPageTitle(postTitle: string, postCategory: string) {
  if (postTitle && postCategory) {
    return `${postTitle} - ${postCategory} | thinkofliving.com`;
  } else if (postTitle) {
    return `${postTitle} | thinkofliving.com`;
  }
  return '';
}

export function generateContentPageTitle(postTitle: string) {
  return `${postTitle} | thinkofliving.com`;
}

const generateTitleAndDescriptionWithMetroStation = (
  termsSlug: string,
  parent: string,
) => {
  if (parent) {
    return {
      title: `โครงการตามแนวรถไฟฟ้าสถานี${termsSlug}${WEBSITE_NAME}`,
      description: `โครงการบ้านและคอนโดใกล้รถไฟฟ้า ${parent} สถานี${termsSlug} สะดวกสบายทุกการเดินทางตอบโจทย์ไลฟ์สไตล์คนในเมือง พร้อมข้อมูลรายละเอียด ราคาโครงการในย่านนี้ และสิ่งอำนวยความสะดวกโดยรอบ`,
    };
  }
  return {
    title: `โครงการตามแนวรถไฟฟ้า${termsSlug}${WEBSITE_NAME}`,
    description: `รวมโครงการบ้านและคอนโดตามแนวรถไฟฟ้า ${termsSlug} พร้อมข้อมูลรายละเอียดทำเล ราคา สิ่งอำนวยความสะดวกโดยรอบ ช่วยให้คุณเปรียบเทียบอสังหาฯในย่าน ${termsSlug} ได้ง่ายขึ้น`,
  };
};
const generateDescriptionWithZoneAndSubZone = (
  termsTaxonomy: string,
  termsSlug: string,
) => {
  if (termsTaxonomy === 'zone') {
    return `${termsSlug} - รวมข้อมูลโครงการบ้านและคอนโดย่าน${termsSlug} ที่น่าสนใจ อัพเดดข้อมูลรายละเอียดราคาอสังหาฯในย่านนี้ก่อนใคร พร้อมข่าวโครงการเปิดใหม่ และรีวิวที่พาไปสัมผัสบรรยากาศมุมมองในย่านนี้ ห้ามพลาด`;
  }
  return `หาโครงการบ้าน ทาวน์โฮม โครงการคอนโดย่าน${termsSlug} อัพเดดข้อมูลทำเล ราคา ช่วยให้คุณเปรียบเทียบอสังหาฯในย่านนี้ ให้คุณได้เห็นตัวเลือกได้มากขึ้นก่อนตัดสินใจซื้อบ้านในทำเลในฝัน`;
};

export const buildTitleAndDescriptionWithLocation = (
  termsSlug: string,
  minPrice: number | string,
  maxPrice: number | string,
  propertyType: PropertyType,
  termsTaxonomy: string,
  parent: string,
) => {
  const isLocation =
    termsTaxonomy === 'zone' ||
    termsTaxonomy === 'road' ||
    termsTaxonomy === 'district';
  const isMetroStation = termsTaxonomy === 'metro_station';
  const propertyTypeInTh = getAllPropertyTypeValues(propertyType);
  const locationMapper = {
    metroStation: generateTitleAndDescriptionWithMetroStation(
      termsSlug,
      parent,
    ),
    location: {
      title: `โครงการในย่าน${termsSlug}${WEBSITE_NAME}`,
      description: generateDescriptionWithZoneAndSubZone(
        termsTaxonomy,
        termsSlug,
      ),
    },
    locationPropertyType: {
      title: `${propertyTypeInTh}ในย่าน${termsSlug}${WEBSITE_NAME}`,
      description: `รวมโครงการ${propertyTypeInTh}ย่าน${termsSlug}  พร้อมบทความรีวิวที่จะช่วยคุณค้นหาและเปรียบเทียบโครงการอสังหาริมทรัพย์ตามความต้องการของคุณ อีกทั้งยังมีข้อมูลอินไซต์จากทีมงานผู้เชี่ยวชาญด้านอสังหาฯ`,
    },
    locationPropertyTypePriceRange: {
      title: `${propertyTypeInTh}ในย่าน${termsSlug}ราคา ${minPrice} - ${maxPrice}${WEBSITE_NAME}`,
      description: `รวมโครงการ${propertyTypeInTh}ย่าน${termsSlug} ราคา${minPrice} - ${maxPrice} พร้อมบทความรีวิวที่จะช่วยคุณค้นหาและเปรียบเทียบโครงการอสังหาริมทรัพย์ตามความต้องการของคุณ อีกทั้งยังมีข้อมูลอินไซต์จากทีมงานผู้เชี่ยวชาญด้านอสังหาฯ`,
    },
    locationPropertyTypeMinPrice: {
      title: `${propertyTypeInTh}ย่าน${termsSlug}ตั้งแต่${minPrice}${WEBSITE_NAME}`,
      description: `โครงการ${propertyTypeInTh} ย่าน${termsSlug}ราคาตั้งแต่ ${minPrice} ขี้นไป ช่วยคุณหาและเปรียบเทียบโครงการอสังหาฯตามความต้องการของคุณ พร้อมข้อมูลอัพเดทและบทวิเคราะห์โครงการล่าสุดอย่างละเอียด`,
    },
    locationPropertyTypeMaxPrice: {
      title: `${propertyTypeInTh}ย่าน${termsSlug}ไม่เกิน${maxPrice}${WEBSITE_NAME}`,
      description: `โครงการ${propertyTypeInTh} ย่าน${termsSlug}ราคาไม่เกิน ${maxPrice} ขี้นไป ช่วยคุณหาและเปรียบเทียบโครงการอสังหาฯตามความต้องการของคุณ พร้อมข้อมูลอัพเดทและบทวิเคราะห์โครงการล่าสุดอย่างละเอียด`,
    },
    locationMinPrice: {
      title: `อสังหาฯย่าน${termsSlug}ตั้งแต่${minPrice}${WEBSITE_NAME}`,
      description: `โครงการบ้าน คอนโด ทาวน์โฮมย่าน${termsSlug} ราคาตั้งแต่ ${minPrice} ขี้นไปช่วยคุณหาและเปรียบเทียบโครงการอสังหาฯตามความต้องการของคุณ พร้อมข้อมูลอัพเดทล่าสุดข้อมูลโครงการใกล้เคียงที่จะให้คุณตัดสินใจซื้อ-ขายได้อย่างถูกต้อง`,
    },
    locationMaxPrice: {
      title: `อสังหาฯย่าน${termsSlug}ไม่เกิน${maxPrice}${WEBSITE_NAME}`,
      description: `โครงการบ้าน คอนโด ทาวน์โฮมย่าน${termsSlug} ราคาไม่เกิน ${maxPrice} ช่วยคุณหาและเปรียบเทียบโครงการอสังหาฯตามความต้องการของคุณ พร้อมข้อมูลโครงการใกล้เคียงที่จะให้คุณตัดสินใจซื้อ-ขายได้อย่างถูกต้อง`,
    },
    locationPriceRange: {
      title: `โครงการในย่าน${termsSlug}ช่วงราคา${minPrice} - ${maxPrice}${WEBSITE_NAME}`,
      description: `โครงการบ้าน คอนโด ทาวน์โฮมย่าน${termsSlug} ในช่วงราคา ${minPrice} - ${maxPrice} ช่วยคุณหาและเปรียบเทียบโครงการอสังหาฯตามทำเลและช่วงราคาที่คุณต้องการ พร้อมข้อมูลโครงการใกล้เคียงที่จะให้คุณตัดสินใจซื้อ-ขายได้อย่างถูกต้อง`,
    },
  };
  if (propertyTypeInTh) {
    if (maxPrice && minPrice) {
      return locationMapper['locationPropertyTypePriceRange'];
    }
    if (minPrice) {
      return locationMapper['locationPropertyTypeMinPrice'];
    }
    if (maxPrice) {
      return locationMapper['locationPropertyTypeMaxPrice'];
    }
    return locationMapper['locationPropertyType'];
  }
  if (minPrice && maxPrice) {
    return locationMapper['locationPriceRange'];
  }
  if (minPrice) {
    return locationMapper['locationMinPrice'];
  }
  if (maxPrice) {
    return locationMapper['locationMaxPrice'];
  }
  if (isLocation) {
    return locationMapper['location'];
  }
  if (isMetroStation) {
    return locationMapper['metroStation'];
  }

  return buildTitleAndDescriptionWithNoFilter();
};

export const buildTitleAndDescriptionWithPropertyType = (
  propertyType: PropertyType,
  minPrice: number | string,
  maxPrice: number | string,
) => {
  const propertyTypeInTh = getAllPropertyTypeValues(propertyType);
  const propertyTypeMapper = {
    propertyTypeMinPrice: {
      title: `โครงการ${propertyTypeInTh}ทั่วประเทศราคาตั้งแต่ ${minPrice}${WEBSITE_NAME}`,
      description: `ค้นหาโครงการ${propertyTypeInTh} ทั่วประเทศช่วงราคาเริ่มต้น ${minPrice} ครบทั้งบทความรีวิว พรีวิว ข้อมูลราคาล่าสุดและรายละเอียดความคืบหน้าโครงการอสังหาฯทั่วประเทศที่คุณสนใจ อัพเดทก่อนใครกับthinkofliving`,
    },
    propertyTypeMaxPrice: {
      title: `โครงการ${propertyTypeInTh}ทั่วประเทศราคาไม่เกิน ${maxPrice}${WEBSITE_NAME}`,
      description: `ค้นหาโครงการ${propertyTypeInTh} ทั่วประเทศช่วงราคาไม่เกิน ${maxPrice} ครบทั้งบทความรีวิว พรีวิว ข้อมูลราคาล่าสุดและรายละเอียดความคืบหน้าโครงการอสังหาฯทั่วประเทศที่คุณสนใจ อัพเดทก่อนใครกับthinkofliving`,
    },
    propertyTypePriceRange: {
      title: `โครงการ${propertyTypeInTh}ทั่วประเทศช่วงราคา ${minPrice} – ${maxPrice}${WEBSITE_NAME}`,
      description: `ค้นหาโครงการ${propertyTypeInTh} ทั่วประเทศช่วงราคา ${minPrice} – ${maxPrice} ครบทั้งบทความรีวิว พรีวิว ข้อมูลราคาล่าสุดและรายละเอียดความคืบหน้าโครงการอสังหาฯทั่วประเทศที่คุณสนใจ อัพเดทก่อนใครกับthinkofliving`,
    },
    propertyType: {
      title: `โครงการ${propertyTypeInTh}ทั่วประเทศ${WEBSITE_NAME}`,
      description: `ค้นหาโครงการ${propertyTypeInTh} ทั่วประเทศ ครบทั้งบทความรีวิว พรีวิว ข้อมูลราคาล่าสุดและรายละเอียดความคืบหน้าโครงการอสังหาฯทั่วประเทศที่คุณสนใจ อัพเดทก่อนใครกับthinkofliving`,
    },
  };
  if (minPrice && maxPrice) {
    return propertyTypeMapper['propertyTypePriceRange'];
  }
  if (minPrice) {
    return propertyTypeMapper['propertyTypeMinPrice'];
  }
  if (maxPrice) {
    return propertyTypeMapper['propertyTypeMaxPrice'];
  }
  return propertyTypeMapper['propertyType'];
};
export const buildTitleAndDescriptionWithPrice = (
  minPrice: string | number,
  maxPrice: string | number,
) => {
  const priceMapper = {
    priceRange: {
      title: `โครงการอสังหาฯทั่วประเทศช่วงราคา${minPrice} – ${maxPrice}${WEBSITE_NAME}`,
      description: `ค้นหาโครงการอสังหาริมทรัพย์ทั่วประเทศช่วงราคา ${minPrice} - ${maxPrice} ทุกโครงการบ้าน คอนโด ทาวน์โฮม ครบทั้งบทความรีวิว พรีวิว ข้อมูลราคาล่าสุดและรายละเอียดความคืบหน้าโครงการอสังหาฯทั่วประเทศที่คุณสนใจ ห้ามพลาด`,
    },
    minPrice: {
      title: `โครงการอสังหาฯทั่วประเทศราคาตั้งแต่${minPrice}${WEBSITE_NAME}`,
      description: `ค้นหาโครงการอสังหาริมทรัพย์ทั่วประเทศราคาตั้งแต่ ${minPrice} ทุกโครงการบ้าน คอนโด ทาวน์โฮม ครบทั้งบทความรีวิว พรีวิว ข้อมูลราคาล่าสุดและรายละเอียดความคืบหน้าโครงการอสังหาฯทั่วประเทศที่คุณสนใจ ห้ามพลาด`,
    },
    maxPrice: {
      title: `โครงการอสังหาฯทั่วประเทศราคาไม่เกิน${maxPrice}${WEBSITE_NAME}`,
      description: `ค้นหาโครงการอสังหาริมทรัพย์ทั่วประเทศราคาไม่เกิน ${maxPrice} ทุกโครงการบ้าน คอนโด ทาวน์โฮม ครบทั้งบทความรีวิว พรีวิว ข้อมูลราคาล่าสุดและรายละเอียดความคืบหน้าโครงการอสังหาฯทั่วประเทศที่คุณสนใจ ห้ามพลาด`,
    },
  };
  if (minPrice && maxPrice) {
    return priceMapper['priceRange'];
  }
  if (minPrice) {
    return priceMapper['minPrice'];
  }
  return priceMapper['maxPrice'];
};
export const buildTitleAndDescriptionWithNoResult = (
  termsSlug: string,
  freeText: string,
) => {
  const noSearchResultFilter = termsSlug ? termsSlug : freeText;
  const noSearchResultText = isEmpty(noSearchResultFilter)
    ? ''
    : ` ${noSearchResultFilter} `;

  return {
    title: `ไม่ค้นพบหน้ารายละเอียดโครงการ${trimEnd(
      noSearchResultText,
    )}${WEBSITE_NAME}`,
    description: `เราไม่ค้นพบหน้ารายละเอียดโครงการ${noSearchResultText}กรุณาตรวจสอบข้อมูลตัวสะกดและกรอกอีกครั้ง คุณสามารถดูข้อมูลโครงการอื่นๆ บทความรีวิวหรือบทวิเคราะห์เพิ่มเติมจากผลการค้นหาอื่นๆได้ ไม่ว่าจะค้นหาด้วยสถานที่ ชื่อรถไฟฟ้าหรือชื่อโครงการที่คุณสนใจ`,
  };
};
export const buildTitleAndDescriptionWithFreeText = (freeText: string) => {
  return {
    title: `ผลการค้นหา${freeText}${WEBSITE_NAME}`,
    description: `พบกับรายละเอียดโครงการ${freeText} ข้อมูลอัพเดทใหม่ล่าสุดในประเทศไทย พร้อมทั้งอ่านรีวิว, พรีวิว, ดูวิดีโอรีวิว ข่าวในวงการอสังหาฯได้อย่างครบถ้วนที่ thinkofliving.com`,
  };
};
export const buildTitleAndDescriptionWithNoFilter = () => {
  return {
    title: `รวมอสังหาริมทรัพย์ทั่วประเทศ${WEBSITE_NAME}`,
    description: `ค้นหาโครงการอสังหาริมทรัพย์ทั่วประเทศ ทุกโครงการบ้าน คอนโด ทาวน์โฮม ครบทั้งบทความรีวิว พรีวิว ข้อมูลราคาล่าสุดและรายละเอียดความคืบหน้าโครงการอสังหาฯทั่วประเทศที่คุณสนใจ ห้ามพลาด`,
  };
};

export function generateSrpSeoTitleAndDescription(
  advanceSearchQueries: AdvanceSearchQueries,
  searchParams: { termsTaxonomy?: string; termsSlug?: string },
  freeText: string,
  isShowNoResult: boolean,
  parent: string,
) {
  const { minPrice, maxPrice, propertyType } = advanceSearchQueries;
  const { termsTaxonomy, termsSlug } = searchParams;

  if (isShowNoResult) {
    return buildTitleAndDescriptionWithNoResult(termsSlug, freeText);
  }
  if (freeText) {
    return buildTitleAndDescriptionWithFreeText(freeText);
  }
  if (termsSlug) {
    return buildTitleAndDescriptionWithLocation(
      termsSlug,
      minPrice,
      maxPrice,
      propertyType,
      termsTaxonomy,
      parent,
    );
  }

  if (propertyType) {
    return buildTitleAndDescriptionWithPropertyType(
      propertyType,
      minPrice,
      maxPrice,
    );
  }

  if (minPrice || maxPrice) {
    return buildTitleAndDescriptionWithPrice(minPrice, maxPrice);
  }

  return buildTitleAndDescriptionWithNoFilter();
}

export function getSrpSeoData({
  freeText,
  advanceSearchQueries,
  canonicalLink,
  isShowNoResult,
  searchParams,
  parent,
}: {
  freeText: string;
  advanceSearchQueries: AdvanceSearchQueries;
  canonicalLink: string;
  isShowNoResult: boolean;
  searchParams: { termsTaxonomy?: string; termsSlug?: string };
  parent: string;
}) {
  const metaObject = generateSrpSeoTitleAndDescription(
    advanceSearchQueries,
    searchParams,
    freeText,
    isShowNoResult,
    parent,
  );

  const sharpieImgUri = handleShareImageUrl(JSON.stringify(logo));
  const metaRobot = `${config.metaRobotSrp}`;
  const seoTitle = metaObject?.title;
  const description = metaObject?.description;
  return {
    canonicalLink,
    sharpieImgUri,
    metaRobot,
    seoTitle,
    description,
  };
}
